import { parseItems as parseUnsplash } from '../../unsplash/parsers/items';
import { parseItems as parseShutterstock } from '../../shutterstock/parsers/items';
import { toItem } from '../../private-site/mappers/item';
import { toFolder } from '../../private-site/mappers/folder';
import { get } from '../../../utils/utils';
import { defaultSettings as privateSettings } from '../../private-site/settings';
import { defaultSettings as publicSettings } from '../../public/settings';
import { parseItems as parsePublicItems } from '../../public/parsers/items';
import { chain, find, head, pipe, prop, propEq } from 'ramda';
import { SourceName } from '../../../constants/SourceName';
export const findCategoryBySubCategoryId = (subCategoryId, categories) => () => pipe(chain(prop('subFolders')), find(pipe(prop('subFolders'), head, propEq('id', subCategoryId))))(categories);
export const getCategoryProperty = (propName, childCategoryId, categories) => pipe(findCategoryBySubCategoryId(childCategoryId, categories), prop(propName))(categories);
const privateFilesFolders = (data, siteToken, source) => {
  const resFiles = get(data, 'file');
  const files = (resFiles && resFiles.items || []).map(filesData => ({
    ...toItem(filesData, {
      ...privateSettings,
      siteMediaToken: siteToken
    }),
    ...(source && {
      source
    }),
    hasMoreItemsInThisCategory: resFiles.cursor !== ''
  }));
  const resFolders = get(data, 'folder');
  const folders = (resFolders && resFolders.items || []).map(folderData => ({
    ...toFolder(folderData, privateSettings),
    ...(source && {
      source
    }),
    hasMoreItemsInThisCategory: resFolders.cursor !== ''
  }));
  return {
    files,
    folders
  };
};
export const toSearchResults = (data, _ref) => {
  let {
    publicMediaCategories,
    siteToken
  } = _ref;
  const result = {};
  if (data.private) {
    if (data.private.media) {
      const {
        files,
        folders
      } = privateFilesFolders(data.private.media, siteToken, SourceName.Private);
      result.privateFiles = {
        data: files
      };
      result.privateFolders = {
        data: folders
      };
    }
    if (data.private.trash) {
      const {
        files,
        folders
      } = privateFilesFolders(data.private.trash, siteToken, SourceName.Trash);
      result.trashFiles = {
        data: files
      };
      result.trashFolders = {
        data: folders
      };
    }
    if (data.private.visitor) {
      const {
        files
      } = privateFilesFolders(data.private.visitor, siteToken, SourceName.VisitorsUploads);
      result.visitorFiles = {
        data: files
      }; // visitor uploads contains only files
    }
  }
  if (data.public) {
    Object.keys(data.public).forEach(categoryId => {
      const subCategoryTitle = getCategoryProperty('name', categoryId, publicMediaCategories);
      const parentCategoryId = getCategoryProperty('id', categoryId, publicMediaCategories);
      if (data.public[categoryId].items.length > 0) {
        const categoryData = {
          ...data.public[categoryId],
          items: data.public[categoryId].items.map(item => ({
            ...item,
            categoryId,
            hasMoreItemsInThisCategory: data.public[categoryId].nextPage && data.public[categoryId].nextPage !== null,
            source: SourceName.Public,
            subCategoryTitle,
            parentCategoryId
          }))
        };
        result[categoryId] = parsePublicItems({
          data: categoryData
        }, publicSettings);
      }
    });
  }
  if (data.unsplash) {
    result.unsplash = parseUnsplash({
      data: data.unsplash
    });
  }
  if (data['shutterstock-video']) {
    result.shutterStockVideo = parseShutterstock({
      data: data['shutterstock-video']
    });
  }
  if (data.shutterstock) {
    result.shutterstock = parseShutterstock({
      data: data.shutterstock
    });
  }
  return result;
};